var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-md",attrs:{"id":"news"}},[_c('div',{staticClass:"text-18 font-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('BaseLine',{staticClass:"mt-md mb-md"}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }